import Home from "@/pages/Home";
import Hydro from "@/pages/Hydro";

const routes = [
  {
    path: "/",
    redirect: "/hydro",
  },
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "hydro",
        name: "Hydrological",
        component: Hydro,
        children: [
          {
            path: "dummy",
          },
        ],
      },
    ],
  },
];

export default routes;
